var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBannerOverlay = function SvgBannerOverlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 719 719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#banner-overlay_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M2.06 2.032v722.126h112.678v-611.15H734.23V2.032H2.06Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.258 224.14v500.018h112.678V335.273H734.23V224.14H227.258Z",
    fill: "#C1306F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M452.614 446.405v277.753h112.678v-166.62H734.23V446.405H452.614ZM734.071 668.514h-56.259v55.488h56.259v-55.488Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "banner-overlay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h719v719H0z"
  })))));
};
export default SvgBannerOverlay;